import type { MultiTilePaintMode } from "@west-marches/shared";
import type { TileSetRecord } from "@west-marches/shared";

export function getEffectiveTileSetPaintMode(
  tileSet: Pick<TileSetRecord, "paint_mode">,
  tileCount: number,
): MultiTilePaintMode {
  if (tileSet.paint_mode === "dynamic" || tileSet.paint_mode === "ordered") {
    return tileSet.paint_mode;
  }

  return tileCount > 1 ? "dynamic" : "ordered";
}
